const map = {
	"./athlete.js": 94636,
	"./auth.js": 71665,
	"./chat.js": 93553,
	"./cloud.js": 45914,
	"./dietPlan.js": 3686,
	"./financialsPanel.js": 42293,
	"./food.js": 2931,
	"./notes.js": 19582,
	"./pdf.js": 16089,
	"./quota.js": 22399,
	"./settings.js": 50094,
	"./sports.js": 38056,
	"./ui.js": 27765
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98989;